import type { FC } from 'react';

import { RosterDialog } from './roster-dialog';
import type { RosterFuseUpProps } from './roster-fuse-up';
import { RosterFuseUp } from './roster-fuse-up';
import { DialogCloseButton } from '../../components/dialog';

export interface RosterFuseUpDialogProps {
  contentProps?: RosterFuseUpProps;
  onClose?: () => void;
  open?: boolean;
}
export const RosterFuseUpDialog: FC<RosterFuseUpDialogProps> = ({
  contentProps,
  onClose,
  open = true,
}) => {
  if (!contentProps) return null;
  return (
    <RosterDialog dataId="roster-fuseup-dialog" onClose={onClose} open={open}>
      <RosterFuseUp {...contentProps} />
      <DialogCloseButton onClose={onClose} />
    </RosterDialog>
  );
};
